module.exports = __WEBPACK_EXTERNAL_MODULE_34__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/utils/MemUtil"
// module id = 34
// module chunks = 1